import { useEffect } from 'react';
import { startIntercomSurvey } from 'shared/helpers/Intercom';
import { LocalStore, useLocalStore } from 'shared/helpers/Store';

interface IntercomSurveyOptions {
  surveyId: string;
  isEnabled: boolean;
  seenStateKey: string;
}

export function useIntercomSurvey({
  surveyId,
  isEnabled,
  seenStateKey,
}: IntercomSurveyOptions) {
  const surveySeenState = useLocalStore(seenStateKey);

  useEffect(() => {
    if (surveyId && isEnabled && surveySeenState !== 'seen') {
      startIntercomSurvey(surveyId);
      LocalStore.set(seenStateKey, 'seen');
    }
  }, [isEnabled, surveySeenState, surveyId, seenStateKey]);
}
